import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import { isEmpty } from 'lodash'

const Textbox = React.forwardRef(
  ({ className, errorMsg, label, value, isError = false, ...rest }, ref) => {
    const isFirefox = typeof InstallTrigger !== 'undefined'
    return (
      <div className={cn('textbox', className)}>
        <input
          className={cn('textbox__input', {
            '-has-value': !isEmpty(value),
            '-error': isError,
          })}
          placeholder={isFirefox ? '' : '#'}
          ref={ref}
          type="text"
          value={value}
          {...rest}
        />
        {label && <label className={cn('textbox__label', { '-error': isError })}>{label}</label>}
        {isError && <p className="textbox__error-msg">{errorMsg}</p>}
      </div>
    )
  },
)

Textbox.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string,
  isError: PropTypes.bool,
  errorMsg: PropTypes.string,
}

Textbox.displayName = 'Textbox'

export default Textbox
